import React from "react";
import { ParamsGetUkm } from "../../../constants/types";
import useUkm from "../../../services/queries/useUkm";
import useUser from "../../../services/queries/useUser";
import useSelectedUkm from "../../../services/queries/useSelectedUkm";

const initialParamsUkm: ParamsGetUkm = {
    size: 500,
    page: 1,
    search: "",
};

const usePengaturanPage = () => {
    const [activeTab, setActiveTab] = React.useState(0);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = React.useState(false);
    const { status: userStatus, data: user } = useUser();

    const paramsUkm = React.useMemo(
        () => ({
            ...initialParamsUkm,
            userId: user?.ukmId?.[0],
        }),
        [user?.ukmId],
    );

    const { data: ukm } = useUkm(paramsUkm);

    const { ukmData } = useSelectedUkm(user, ukm);

    const showUkmTab =
        user?.role.id === "10" ||
        (user?.aksesPindahUkm === 1 &&
            user?.akses?.pindahUkm.includes(101) === true);

    const showUkmAttention =
        ukmData?.alamatToko === "-" || !ukmData?.jenisUsaha || !ukmData?.alamatToko;

    const showJuraganButton = user?.role.id === "10" && ukmData?.isPro === 1;

    const handleTabChange = React.useCallback(
        (_event: React.SyntheticEvent, newValue: number) => {
            setActiveTab(newValue);
        },
        [],
    );

    const openLogoutModal = React.useCallback(() => {
        setIsLogoutModalOpen(true);
    }, []);

    const closeLogoutModal = React.useCallback(() => {
        setIsLogoutModalOpen(false);
    }, []);

    return {
        activeTab,
        closeLogoutModal,
        handleTabChange,
        isLogoutModalOpen,
        openLogoutModal,
        showJuraganButton,
        showUkmAttention,
        showUkmTab,
        ukmData,
        userStatus,
    };
};

export default usePengaturanPage;
